export class GodotDocsVersion
{
  static version:string = "4.4"; 
  static newestVersion:string = "4.6";

  static toNewest()
  {
    GodotDocsVersion.version = GodotDocsVersion.newestVersion;
  }
}